<template>
  <div>
    <b-modal
      :visible="value"
      title="Admin giải trình KPI"
      @hide="closeModal"
      size="lg"
      ignore-enforce-focus-selector="input"
    >
      <ValidationObserver ref="formAdd">
        <form @submit.prevent="">
          <div class="row d-flex align-items-center mb-3">
            <label for="" class="col-sm-3 col-form-label">Lý do giải trình:</label>
            <div class="col-sm-9">
              {{ reasons }}
            </div>
          </div>
          <div class="row d-flex align-items-center mb-3">
            <label for="" class="col-sm-3 col-form-label">TB trong kì / Tổng TB:</label>
            <div class="col-sm-9">
              {{ dataEdit ? dataEdit.ratio : '' }}
            </div>
          </div>
          <b-button variant="" @click="fetchSyncData()" class="mr-2">
            Đồng bộ dữ liệu trong kỳ
          </b-button>
          <ValidationProvider rules="required|note_1000" vid="note" name="Thông tin giải trình">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-12 col-form-label"
                >Thông tin giải trình<span style="color: red"> *</span>:</label
              >
              <div class="col-sm-12">
                <textarea
                  class="form-control"
                  v-model.trim="formData.note"
                  placeholder="Nhập thông tin giải trình"
                  rows="3"
                ></textarea>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <p class="text-bold py-3 mt-4">Sửa thông tin KPI (nếu cần)</p>
          <ValidationProvider rules="required" vid="kpi" name="Số KPI">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Số KPI<span style="color: red"> *</span>:</label
              >
              <div class="col-sm-9">
                <b-form-input v-model="formData.kpi" placeholder="nhập số kpi"></b-form-input>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="month" name="Tháng tính KPI">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Tháng tính KPI<span style="color: red"> *</span>:</label
              >
              <div class="col-sm-9">
                <SelectMonth v-model="formData.month" placeholder="Tháng tính KPI"></SelectMonth>
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider rules="required" vid="emailSale" name="Email CVKD">
            <div class="form-group row" slot-scope="{ errors }">
              <label for="" class="col-sm-3 col-form-label"
                >Email CVKD<span style="color: red"> *</span>:</label
              >
              <div class="col-sm-9">
                <Select2
                  v-model="formData.emailSale"
                  :options="optionsListUserByEmail"
                  placeholder="Email CVKD"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button variant="" @click="closeModal" class="mr-2"> Huỷ bỏ </b-button>
          <b-button variant="primary" @click="submit"> Lưu lại </b-button>
        </div>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { getListUserFnByEmail } from '../kpiRecordMx'
  import { DeviceService } from '@/services/device.service'
  import SelectMonth from './SelectMonth.vue'
  export default {
    components: { SelectMonth },
    props: ['value', 'dataEdit', 'deviceKpiLogs'],
    data() {
      return {
        show: true,
        formData: {},
        Config,
        optionsListUserByEmail: [],
        reasons: '',
        showLoading: false,
      }
    },
    watch: {
      value() {
        this.reasons = null
        if (this.value) {
          // created
          this.getListUser()
          this.formData = {
            kpi: String(this.dataEdit.kpi),
            emailSale: this.dataEdit.emailSale,
            month: this.dataEdit.month,
            note: null,
          }
          this.reasons = this.deviceKpiLogs[0]?.note
        }
      },
    },
    methods: {
      closeModal() {
        this.$emit('input', false)
      },
      async submit() {
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) return
        this.formData.kpi = Number(this.formData.kpi)
        this.$emit('submit', { ...this.formData })
      },

      async getListUser() {
        this.optionsListUserByEmail = await getListUserFnByEmail()
      },
      async fetchSyncData() {
        this.showLoading = true
        try {
          const response = await DeviceService.fetchSyncDataKpi({ id: this.dataEdit.id })
          if (response.code === 1000) {
            this.dataEdit = response.data
          } else {
            throw new Error(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
